
import { ResponsiveBar } from '@nivo/bar'


import React from 'react'
import EmptyDoc from '../errorComponents/EmptyDoc';

const HorizontalBarChart = ({ noOfGalaList, keys, xaxis }) => {
    return (
        <>
            {noOfGalaList == undefined ? <EmptyDoc bargraph={true} /> :
                <ResponsiveBar
                    data={noOfGalaList}
                    keys={keys}
                    indexBy="id"
                    layout="horizontal"
                    margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
                    padding={0.35}
                    valueScale={{ type: 'linear' }}
                    indexScale={{ type: 'band', round: true }}
                    colors={{ scheme: 'category10' }}
                    tooltip={({ id, value, color }) => (
                        <div
                            className="bg-white px-4 py-2 d-flex align-items-center justify-content-between gap-2 rounded"
                        >
                            <div className='' style={{ width: '15px', height: '15px', background: color }}></div>
                            <strong className='fs-4 title-font-600'>
                                {id}: {value}
                            </strong>
                        </div>
                    )}
                    theme={{
                        fontSize: 14,
                        fontFamily: 'Poppins',
                        fontWeight: "700",
                        tooltip: {
                            container: {
                                background: '#fff',
                            },
                        },
                    }}
                    defs={[
                        {
                            id: 'dots',
                            type: 'patternDots',
                            background: 'inherit',
                            color: '#38bcb2',
                            size: 4,
                            padding: 1,
                            stagger: true
                        },
                        {
                            id: 'lines',
                            type: 'patternLines',
                            background: 'inherit',
                            color: '#eed312',
                            rotation: -45,
                            lineWidth: 6,
                            spacing: 10
                        }
                    ]}
                    fill={[
                        {
                            match: {
                                id: 'fries'
                            },
                            id: 'dots'
                        },
                        {
                            match: {
                                id: 'sandwich'
                            },
                            id: 'lines'
                        }
                    ]}
                    borderColor={{
                        from: 'color',
                        modifiers: [
                            [
                                'darker',
                                1.6
                            ]
                        ]
                    }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: xaxis,
                        legendPosition: 'middle',
                        legendOffset: 32
                    }}
                    axisLeft={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: 'sq.ft',
                        legendPosition: 'middle',
                        legendOffset: -50
                    }}
                    enableLabel={true}
                    labelSkipWidth={11}
                    labelSkipHeight={12}
                    labelTextColor="#ffffff"
                    legends={[
                        {
                            dataFrom: 'keys',
                            anchor: 'bottom-right',
                            direction: 'column',
                            justify: false,
                            translateX: 120,
                            translateY: 0,
                            itemsSpacing: 2,
                            itemWidth: 100,
                            itemHeight: 20,
                            itemDirection: 'left-to-right',
                            itemOpacity: 0.85,
                            symbolSize: 20,
                            effects: [
                                {
                                    on: 'hover',
                                    style: {
                                        itemOpacity: 1
                                    }
                                }
                            ]
                        }
                    ]}
                    role="application"
                    ariaLabel="bar chart"
                    barAriaLabel={function (e) { return e.id + ": " + e.formattedValue + " in country: " + e.indexValue }}
                />
            }

        </>
    )
}

export default HorizontalBarChart